<template>
  <div>
    <Head :title="`${trip.route.name}`" />
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-indigo-400 hover:text-indigo-600" href="/trips">Поездки</Link>
      <span class="text-indigo-400 font-medium">/</span>
      {{ trip.route.name }} {{ trip.trip_date }} #{{ trip.id }}
    </h1>
    <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="update">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <text-input v-model="form.day" :error="form.errors.day" class="pb-8 pr-6 w-full lg:w-1/4" label="Дата" />
          <text-input v-model="form.hour" :error="form.errors.hour" class="pb-8 pr-6 w-full lg:w-1/6" label="Часы" />
          <text-input v-model="form.minute" :error="form.errors.minute" class="pb-8 pr-6 w-full lg:w-1/6" label="Минуты" />
          <select-input v-model="form.status_id" :error="form.errors.status_id" class="pb-8 pr-6 w-full lg:w-1/2" label="Статус">
            <option :value="null" />
            <option :value="null" />
            <option value="10">черновик</option>
            <option value="20">открыта</option>
            <option value="25">выполняется</option>
            <option value="30">отменена</option>
            <option value="40">завершена</option>
          </select-input>
          <select-input v-model="form.driver_id" :error="form.errors.driver_id" class="pb-8 pr-6 w-full lg:w-1/2" label="Водитель">
            <option :value="null" />
            <option v-for="driver in drivers" :key="driver.id" :value="driver.id">{{ driver.first_name }} {{ driver.last_name }}</option>
          </select-input>
          <select-input v-model="form.car_id" :error="form.errors.car_id" class="pb-8 pr-6 w-full lg:w-1/2" label="Авто">
            <option :value="null" />
            <option v-for="car in cars" :key="car.id" :value="car.id">{{ car.mark }} {{ car.model }} {{ car.color }} {{ car.grn }}</option>
          </select-input>
          <select-input v-model="form.route_id" :error="form.errors.route_id" class="pb-8 pr-6 w-full lg:w-1/2" label="Маршрут">
            <option :value="null" />
            <option v-for="route in routes" :key="route.id" :value="route.id">{{ route.name }}</option>
          </select-input>
          <text-input v-model="form.available_seats" :error="form.errors.available_seats" class="pb-8 pr-6 w-full lg:w-1/2" label="Свободных мест" />
          <text-input v-model="form.price" :error="form.errors.price" class="pb-8 pr-6 w-full lg:w-1/2" label="Цена" />
          <textarea-input v-model="form.comment" :error="form.errors.comment" class="pb-8 pr-6 w-full" label="Комментарии (видны всем)" />
        </div>
        <div class="flex items-center px-8 py-4 bg-gray-50 border-t border-gray-100">
          <button class="text-gray-600 hover:underline" tabindex="-1" type="button" @click="clone">Клонировать поездку</button>
          <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">Сохранить поездку</loading-button>
        </div>
      </form>
    </div>
    <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden mt-8 mb-8">
      <div class="flex flex-wrap -mb-8 -mr-6 p-8">
        <div class="mb-2 w-full">
          <strong>Создана: </strong>{{ trip.created_at }}
        </div>
        <div class="mb-8 w-full">
          <strong>Клиенты: </strong> {{ trip.clients_count }}
        </div>
      </div>
    </div>
    <div class="flex mb-8">
      <h1 id="clients" class="text-3xl font-bold">
        <Link class="text-indigo-400 hover:text-indigo-600" :href="`/trips/${trip.id}/edit`">Клиенты</Link>
      </h1>
      <a v-if="trip.clients_count > 0" class="ml-8 btn-indigo" :href="`/trips/${trip.id}/requestConfirmation`"><span>Запросить всех подтверждение поездки</span></a>
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="pb-4 pt-6 px-6">Имя</th>
          <th class="pb-4 pt-6 px-6">Контакты</th>
          <th class="pb-4 pt-6 px-6">Время записи</th>
          <th class="pb-4 pt-6 px-6">Точка</th>
          <th class="pb-4 pt-6 px-6">Цена</th>
          <th class="pb-4 pt-6 px-6">Мест</th>
          <th class="pb-4 pt-6 px-6">Добавлен</th>
          <th class="pb-4 pt-6 px-6"></th>
        </tr>
        <template v-for="client in trip.clients" :key="client.id">
          <tr class="hover:bg-gray-100 focus-within:bg-gray-100">
            <td class="border-t">
              <Link class="flex items-center px-6 py-4 focus:text-indigo-500" :href="`/trips/${trip.id}/clients/${client.id}/edit`">
                {{ client.name }} {{ client.stats }}
                <icon v-if="client.deleted_at" name="trash" class="flex-shrink-0 ml-2 w-3 h-3 fill-gray-400" />
              </Link>
            </td>
            <td class="border-t">
              <div class="flex items-center px-6 py-4">
                <div v-if="client.phone">
                  {{ client.phone }}
                </div>
                <div>
                  <icon v-if="client.telegraph_chat_id" name="telegram" class="inline-block w-6 h-6" />
                  <icon v-if="client.use_viber" name="viber" class="inline-block w-6 h-6" />
                  <icon v-if="client.use_whatsapp" name="whatsapp" class="inline-block w-6 h-6" />
                </div>
              </div>
            </td>
            <td class="border-t px-6">
              {{ new Date(client.pivot.created_at).toLocaleString('ru-RU') }}
            </td>
            <td class="border-t">
              <Link class="flex items-center px-6 py-4" :href="`/trips/${trip.id}/clients/${client.id}/edit`">
                {{ client.pivot.point_name }} ({{ client.pivot.point_time }}мин)
              </Link>
            </td>
            <td class="border-t">
              <Link class="flex items-center px-6 py-4" :href="`/trips/${trip.id}/clients/${client.id}/edit`" tabindex="-1">
                <div v-if="client.pivot.price">
                  <span v-if="client.pivot.price === client.pivot.final_price">{{ client.pivot.price }}р.</span>
                  <span v-if="client.pivot.price !== client.pivot.final_price">
                    <span style="text-decoration: line-through; color: gray">{{ client.pivot.price }}</span>
                    <span>{{ client.pivot.final_price }}р.</span>
                  </span>
                  <span v-if="client.pivot.paid">
                    (оплачено)
                  </span>
                </div>
              </Link>
            </td>
            <td class="border-t">
              {{ client.pivot.seats }}
            </td>
            <td class="border-t">
              {{ client.pivot.added_by }}
            </td>
            <td class="w-px border-t">
              <button class="flex items-center px-4" @click="removeClient(client.id)" tabindex="-1">
                <icon name="trash" class="block w-6 h-6 fill-red-800" />
              </button>
            </td>
          </tr>
          <tr class="hover:bg-gray-100 focus-within:bg-gray-100">
            <td colspan="8" class="pl-12 pr-6 py-2 text-sm">
              <div class="italic border-l" style="width:70vw; overflow:auto">{{ client.pivot.comment }}</div>
              <div v-if="client.pivot.client_status_id === 0" class="border-l">
                Статус: добавлен, подтверждение не запрошено.
                <Link v-if="client.telegraph_chat_id" class="text-indigo-400 hover:text-indigo-600" :href="`/trips/${trip.id}/clients/${client.id}/status/10`">
                  запросить подтверждение
                </Link>
                <Link v-if="!client.telegraph_chat_id" class="text-indigo-400 hover:text-indigo-600" :href="`/trips/${trip.id}/clients/${client.id}/status/20`">
                  не подключен к боту, подтвердить звонком
                </Link>
              </div>
              <div v-if="client.pivot.client_status_id === 10" class="border-l" style="color: orange">
                Статус: подтверждение запрошено {{ new Date(client.pivot.status_at).toLocaleString('ru-RU') }} ({{ client.pivot.status_by}})
                <Link class="text-indigo-400 hover:text-indigo-600" :href="`/trips/${trip.id}/clients/${client.id}/status/20`">
                  подтвердить звонком
                </Link>
              </div>
              <div v-if="client.pivot.client_status_id === 20" class="border-l" style="color: green">
                Статус: поездка подтверждена {{ new Date(client.pivot.status_at).toLocaleString('ru-RU') }} ({{ client.pivot.status_by}})
              </div>
              <div v-if="client.pivot.client_status_id === 30" class="border-l" style="color: green">
                Статус: клиент на месте {{ new Date(client.pivot.status_at).toLocaleString('ru-RU') }} ({{ client.pivot.status_by}})
              </div>
              <div v-if="client.pivot.client_status_id === 40" class="border-l" style="color: green">
                Статус: клиент в авто {{ new Date(client.pivot.status_at).toLocaleString('ru-RU') }} ({{ client.pivot.status_by}})
              </div>
            </td>
          </tr>
        </template>
        <tr v-if="trip.clients_count === 0">
          <td class="px-6 py-4 border-t" colspan="4">Клиентов нет</td>
        </tr>
      </table>
    </div>
    <h1 id="clientFormHeader" class="mb-8 mt-5 text-3xl font-bold">
      Добавление клиента в поездку
      <a id="showClientFormButton" href="#clientFormHeader" class="ml-8 btn-indigo" @click="showClientForm"><span>Добавить</span></a>
    </h1>
    <div id="clientForm" class="max-w-3xl bg-white rounded-md shadow overflow-hidden mt-8 mb-8 hidden">
      <div class="flex flex-wrap flex-lg-nowrap -mb-8 -mr-6 p-8">
        <input v-model="formClients.search" class="form-input mr-4" autocomplete="off" type="text" name="search" placeholder="Поиск клиента по телефону или имени" />
        <div v-if="clients && clients.length > 1" class="pl-8 pb-2 pt-2 text-muted">Найдено клиентов: {{ clients.length }}, выберите из списка ниже</div>
        <div v-if="clients && clients.length === 1" class="pl-8 pb-2 pt-2 text-muted">
          <Link :href="`/clients/${clients[0].id}/edit`" :target="_blank">
            {{ clients[0].name }} {{ clients[0].phone }} {{ clients[0].stats }}
            <icon v-if="clients[0].telegraph_chat_id" name="telegram" class="inline-block w-6 h-6" />,
            {{ clients[0].city ? clients[0].city : 'ГОРОД НЕУКАЗАН' }}
            {{ clients[0].phone_confirmed ? '' : ' НЕ ПОТВЕРЖДЕН,' }} <i>{{ clients[0].comments }}</i>
          </Link>
        </div>
        <div v-if="!clients" class="pl-8 pb-2 pt-2 text-muted">Клиенты не найдены</div>
      </div>
      <form @submit.prevent="addClient">
        <div class="flex flex-wrap flex-lg-nowrap -mb-8 -mr-6 p-8">
          <select-input v-model="addClientForm.client_id" :error="addClientForm.errors.client_id" class="pb-8 pr-6 w-full" label="Клиент">
            <option :value="null" ></option>
            <option v-for="client in clients" :key="client.id" :value="client.id">{{ client.name }} {{ client.phone }} {{ client.stats }}</option>
          </select-input>
          <div class="pb-8 pr-6 w-full">
            <input v-model="formPoints.search_point" class="form-input" autocomplete="off" type="text" name="search_point" placeholder="Фильтр точки по названию" />
          </div>
          <select-input v-model="addClientForm.point_id" :error="addClientForm.errors.point_id" class="pb-8 pr-6 w-full" label="Точка">
            <option :value="null" />
            <option v-for="point in points" :key="point.id" :value="point.id" :selected="point.pivot.time_to === 0">{{ point.pivot.time_to }} мин {{ point.name }} </option>
          </select-input>
          <text-input v-model="addClientForm.price" :error="addClientForm.errors.price" class="pb-8 pr-6" label="Цена" />
          <select-input v-model="addClientForm.seats" :error="addClientForm.errors.seats" class="pb-8 pr-6" label="Мест">
            <option value="1" :selected="addClientForm.seats === 1">1</option>
            <option value="2" :selected="addClientForm.seats === 2">2</option>
            <option value="3" :selected="addClientForm.seats === 3">3</option>
            <option value="4" :selected="addClientForm.seats === 4">4</option>
            <option value="5" :selected="addClientForm.seats === 5">5</option>
            <option value="6" :selected="addClientForm.seats === 6">6</option>
          </select-input>
          <label class="flex items-center select-none" for="paid">
            <input id="paid" v-model="addClientForm.paid" class="form-check" type="checkbox" />
            <span>Оплачено</span>
          </label>
          <textarea-input v-model="addClientForm.comment" :error="addClientForm.errors.comment" class="pb-8 pr-6 w-full" label="Комментарии" />
        </div>
        <div class="flex items-center px-8 py-4 bg-gray-50 border-t border-gray-100">
          <label class="flex items-center select-none" for="paid">
            <input id="await-list" v-model="addClientForm.only_await" class="form-check" type="checkbox" />
            <span>Добавить в список ожидания</span>
          </label>
          <loading-button :loading="addClientForm.processing" class="btn-indigo ml-auto" type="submit">Добавить</loading-button>
        </div>
      </form>
    </div>
    <div class="flex items-center justify-content-around">
      <h1 id="awaits" class="text-3xl font-bold">
        Лист ожидания
      </h1>
      <a v-if="trip.awaits.length > 0" class="ml-8 btn-indigo" :href="`/trips/${trip.id}/requestAwaitConfirmations`"><span>Пригласить всех в поездку</span></a>
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto mt-8">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="pb-4 pt-6 px-6">Имя</th>
          <th class="pb-4 pt-6 px-6">Контакты</th>
          <th class="pb-4 pt-6 px-6">Время записи</th>
          <th class="pb-4 pt-6 px-6">Точка</th>
          <th class="pb-4 pt-6 px-6">Инициатор записи</th>
          <th class="pb-4 pt-6 px-6" colspan="2">Комментарии</th>
        </tr>
        <tr v-for="awaitingClient in trip.awaits" :key="awaitingClient.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
          <td class="border-t">
            <Link class="flex items-center px-6 py-4 focus:text-indigo-500" :href="`/trips/${trip.id}/awaits/${awaitingClient.pivot.client_id}/edit`">
              {{ awaitingClient.name }} {{ awaitingClient.stats }}
            </Link>
          </td>
          <td class="border-t">
            <div class="flex items-center px-6 py-4">
              <div v-if="awaitingClient.phone">
                {{ awaitingClient.phone }}
              </div>
              <div>
                <icon v-if="awaitingClient.telegraph_chat_id" name="telegram" class="inline-block w-6 h-6" />
                <icon v-if="awaitingClient.use_viber" name="viber" class="inline-block w-6 h-6" />
                <icon v-if="awaitingClient.use_whatsapp" name="whatsapp" class="inline-block w-6 h-6" />
              </div>
            </div>
          </td>
          <td class="border-t px-6">
            <Link class="flex items-center px-6 py-4" :href="`/trips/${trip.id}/awaits/${awaitingClient.id}/edit`">
              {{ new Date(awaitingClient.pivot.created_at).toLocaleString('ru-RU') }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-6 py-4" :href="`/trips/${trip.id}/awaits/${awaitingClient.id}/edit`">
              {{ awaitingClient.pivot.point_name }} ({{ awaitingClient.pivot.point_time }}мин)
            </Link>
          </td>
          <td class="px-6 border-t">
            {{ awaitingClient.pivot.added_by }}
          </td>
          <td class="px-6 border-t">
            {{ awaitingClient.pivot.comment }}
          </td>
          <td class="px-6 border-t">
            <Link class="flex items-center px-6 py-4" :href="`/trips/${trip.id}/awaits/${awaitingClient.id}/edit`">
              <Icon name="cheveron-right" class="block w-6 h-6" />
            </Link>
          </td>
        </tr>
        <tr v-if="trip.awaits.length === 0">
          <td class="px-6 py-4 border-t" colspan="7">Лист ожидания пуст</td>
        </tr>
      </table>
    </div>
    <h1 class="mb-8 mt-5 text-3xl font-bold">
      Отмены в поездке
    </h1>
    <div class="bg-white rounded-md shadow overflow-x-auto mt-8">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="pb-4 pt-6 px-6">Имя</th>
          <th class="pb-4 pt-6 px-6">Контакты</th>
          <th class="pb-4 pt-6 px-6">Время отмены</th>
          <th class="pb-4 pt-6 px-6">Инициатор отмены</th>
          <th class="pb-4 pt-6 px-6">Время до начала поездки</th>
        </tr>
        <tr v-for="tripCancel in trip.cancels" :key="tripCancel.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
          <td class="border-t">
            <Link class="flex items-center px-6 py-4 focus:text-indigo-500" :href="`/trips/${tripCancel.trip_id}/edit`">
              {{ tripCancel.client.name }}
            </Link>
          </td>
          <td class="border-t">
            <div class="flex items-center px-6 py-4">
              <div v-if="tripCancel.client.phone">
                {{ tripCancel.client.phone }}
              </div>
              <div>
                <icon v-if="tripCancel.client.telegraph_chat_id" name="telegram" class="inline-block w-6 h-6" />
                <icon v-if="tripCancel.client.use_viber" name="viber" class="inline-block w-6 h-6" />
                <icon v-if="tripCancel.client.use_whatsapp" name="whatsapp" class="inline-block w-6 h-6" />
              </div>
            </div>
          </td>
          <td class="border-t px-6">
            {{ tripCancel.date }}
          </td>
          <td class="px-6 border-t">
            {{ tripCancel.user ? tripCancel.user.first_name : 'самостоятельно' }}
          </td>
          <td class="border-t px-6">
            {{ tripCancel.time_before_start_readable }}
          </td>
        </tr>
        <tr v-if="trip.cancels.length === 0">
          <td class="px-6 py-4 border-t" colspan="4">В поездке не было отмен</td>
        </tr>
      </table>
    </div>
    <h1 class="mb-8 mt-5 text-3xl font-bold">
      Журнал поездки
    </h1>
    <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden mt-8 mb-8">
      <div class="flex flex-wrap flex-lg-nowrap -mb-8 -mr-6 p-8">
        <div v-for="entry in journal_entries" :key="entry.id" class="mb-2">
          <strong>{{ entry.created_at }}:</strong><icon v-if="entry.bot" name="telegram" class="inline-block w-4 h-4" /> {{ entry.subject }}
        </div>
      </div>
    </div>

    <div>

    </div>
    <div>

    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TextareaInput from '@/Shared/TextareaInput'
import Icon from '@/Shared/Icon'
import throttle from 'lodash/throttle'
import pickBy from 'lodash/pickBy'
import client from '@/Pages/WebApp/Client.vue'

export default {
  computed: {
    client() {
      return client
    }
  },
  components: {
    TextareaInput,
    Head,
    Icon,
    Link,
    LoadingButton,
    SelectInput,
    TextInput,
  },
  layout: Layout,
  props: {
    trip: Object,
    drivers: Array,
    cars: Array,
    cancels: Array,
    routes: Array,
    clients: Array,
    points: Array,
    journal_entries: Array,
    defaultPrice: String,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        day: this.trip.day,
        hour: this.trip.hour,
        minute: this.trip.minute,
        status_id: this.trip.status_id,
        route_id: this.trip.route_id,
        driver_id: this.trip.driver_id,
        phone: this.trip.phone,
        car_id: this.trip.car_id,
        available_seats: this.trip.available_seats,
        price: this.trip.price,
        comment: this.trip.comment,
      }),
      addClientForm: this.$inertia.form({
        client_id: '',
        point_id: '',
        price: this.trip.price,
        comment: '',
        paid: false,
        address: null,
        seats: 1,
        only_await: false,
      }),
      formClients: {
        search: null,
        clients: null,
      },
      formPoints: {
        search_point: null,
        points: null,
      },
    }
  },
  watch: {
    formClients: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get(`/trips/${this.trip.id}/edit`, pickBy(this.formClients), { preserveScroll: true, preserveState: true, only: ['clients'] })
      }, 150),
    },
    formPoints: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get(`/trips/${this.trip.id}/edit`, pickBy(this.formPoints), { preserveScroll: true, preserveState: true, only: ['points'] })
      }, 150),
    },
  },
  methods: {
    update() {
      this.form.put(`/trips/${this.trip.id}`)
    },
    clone() {
      this.$inertia.get(`/trips/${this.trip.id}/clone`)
    },
    restore() {
      if (confirm('Вы уверены что хоите восстановить поездку?')) {
        this.$inertia.put(`/trips/${this.trip.id}/restore`)
      }
    },
    addClient() {
      this.addClientForm.post(`/trips/${this.trip.id}/clients`)
    },
    removeClient(id) {
      if (confirm('Вы уверены что хотите удалить клиента из поездки?')) {
        this.$inertia.get(`/trips/${this.trip.id}/clients/${id}/detach`)
      }
    },
    requestAwaitConfirmations() {
      this.$inertia.get(`/trips/${this.trip.id}/awaits/${this.client.id}/requestAwaitConfirmations`)
    },
    showClientForm() {
      document.getElementById('showClientFormButton').classList.add('hidden')
      document.getElementById('clientForm').classList.remove('hidden')
    },
  },
}
</script>
